import * as React from "react";

export class EventCell extends React.PureComponent<{ modifier?: string }, {}> {
    render() {
        let clsMdf = this.props.modifier ? ` rj-superbanner__event-names-cell--${this.props.modifier}` : "";
        let dataUat = this.props.modifier ? `superbanner-event-names-cell-${this.props.modifier}` : "superbanner-event-names-cell";

        return (
            <div className={`rj-superbanner__event-names-cell${clsMdf}`} data-uat={dataUat}>
                {this.props.children}
            </div>
        )
    }
}